import {
    STATSIG_GET_EVENT_DATA_FOR_STATSIG_USER,
    STATSIG_GET_EVENT_DATA_FOR_STATSIG_USER_SUCCESS,
    STATSIG_GET_EVENT_DATA_FOR_STATSIG_USER_FAILURE,
    STATSIG_GET_EVENT_DATA_FOR_CLEAR_ERROR,
} from './actionTypes/statsig-action-types';

import * as tmsEventsApi from '../api/tmsEventsApi';
import { showErrorPopup } from './notification-actions';

export const getEventForUpdatingStatsigUser = (eventId) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: 'SPLASH_SHOW' });
    dispatch({ type: STATSIG_GET_EVENT_DATA_FOR_STATSIG_USER });

    try {
        const res = await tmsEventsApi.getFeatureFlagParameterForEvent(mainApi, { eventId });
        if (res.status === 200) {
            dispatch({
              type: STATSIG_GET_EVENT_DATA_FOR_STATSIG_USER_SUCCESS,
                payload: res.data,
            });
        } else {
            dispatch(showErrorPopup({
                message: 'Error loading event',
                error: res?.data?.DisplayMessage,
            }));
        }
        dispatch({ type: 'SPLASH_HIDE' });
    } catch (error) {
        dispatch({ type: 'SPLASH_HIDE' });
        const data = error.response ? error.response.data : null;
        const redirectUrl = data?.clubId ? `/clubs/${data.clubId}` : '/';
        const errorMessage = error.response?.data?.DisplayMessage || 'Unknown error';

        dispatch({
            type: STATSIG_GET_EVENT_DATA_FOR_STATSIG_USER_FAILURE,
            payload: {
                redirectUrl,
                errorMessage,
            },
        });
    }
};

export const clearStatsigError = () => (dispatch) => {
  dispatch({ type: STATSIG_GET_EVENT_DATA_FOR_CLEAR_ERROR });
};
